const IntermediateResellerIcon = ({ ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_12475_41664)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.77496 4.23247L4.1754 7.86562C4.1283 7.91187 4.10419 7.97053 4.10419 8.02925H0C0 7.97234 0.0230346 7.91544 0.0691037 7.86831L7.77287 0.0915937C7.78332 0.0800312 7.79693 0.0693438 7.81055 0.0586875C7.86603 0.0195625 7.93304 0 8.00005 0V4.14356C7.9163 4.14356 7.83358 4.17378 7.77496 4.23247Z"
          fill="#FFE566"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.1733 8.19023L7.77287 11.8234C7.78438 11.8358 7.79693 11.8465 7.81055 11.8572C7.86603 11.8963 7.93304 11.9159 8.00005 11.915V15.9999H7.81055C7.79796 15.991 7.78644 15.9803 7.77496 15.9696L0.071201 8.19289C0.0241017 8.14667 0 8.08798 0 8.0293H4.10419C4.10419 8.0862 4.1262 8.14311 4.1733 8.19023Z"
          fill="#FFC24D"
        />
        <path
          d="M4.17336 7.86842L7.77293 4.23527C7.78338 4.22371 7.79699 4.21214 7.81061 4.20236C7.9352 4.11346 8.12051 4.1268 8.22523 4.23261L11.8248 7.86577C11.9179 7.95733 11.9221 8.09517 11.8279 8.1903L8.22836 11.8235C8.21684 11.8359 8.20429 11.8466 8.18961 11.8572C8.06502 11.9453 7.87971 11.9319 7.77499 11.8261L4.17542 8.19296C4.08229 8.10139 4.07916 7.96355 4.17336 7.86842Z"
          fill="#FFF480"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.22512 4.23247L11.8247 7.86563C11.8718 7.91188 11.8969 7.97053 11.8969 8.02925H16C16 7.97234 15.978 7.91544 15.9309 7.86831L8.22825 0.0915938C8.21673 0.0800313 8.20418 0.0693438 8.1895 0.0586875C8.13401 0.0195625 8.06701 0 8 0V4.14356C8.08379 4.14356 8.16753 4.17378 8.22512 4.23247Z"
          fill="#FFC24D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.8278 8.19023L8.22825 11.8234C8.21673 11.8358 8.20418 11.8465 8.1895 11.8572C8.13401 11.8963 8.06701 11.9159 8 11.915V15.9999H8.1895C8.20209 15.991 8.21463 15.9803 8.22512 15.9696L15.9288 8.19289C15.9759 8.14667 16 8.08798 16 8.0293H11.8969C11.8969 8.0862 11.8738 8.14311 11.8278 8.19023Z"
          fill="#FF9833"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.22825 11.8233L11.8278 8.19018C11.8738 8.14305 11.8969 8.08615 11.8969 8.02924C11.8969 7.97056 11.8718 7.91187 11.8247 7.86562L8.22512 4.23246C8.16753 4.17377 8.08379 4.14355 8 4.14355V11.9149C8.06701 11.9158 8.13401 11.8963 8.1895 11.8571C8.20418 11.8465 8.21673 11.8358 8.22825 11.8233Z"
          fill="#FFE566"
        />
      </g>
      <defs>
        <clipPath id="clip0_12475_41664">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IntermediateResellerIcon;
